export const StatusIcon = ({ className = "" }) => {
    return (
        <svg width="42" height="21" viewBox="0 0 42 21" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1.70061" y="1.45598" width="38.8619" height="18.3099" rx="9.15497" stroke="#1E40AF" stroke-width="2.24203" />
            <circle cx="29.5393" cy="10.6105" r="6.53926" fill="#1E40AF" />
        </svg>
    )
}
